import { useCallback } from 'react';

/**
 * Custom hook for smooth scrolling functionality
 */
export const useSmoothScroll = () => {
  const scrollToElement = useCallback((elementId: string, offset: number = 120) => {
    const element = document.getElementById(elementId);
    if (element) {
      const elementPosition = element.offsetTop - offset;
      
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
      
      // Update URL hash without triggering scroll
      window.history.replaceState(null, '', `#${elementId}`);
    }
  }, []);

  const scrollToTop = useCallback((behavior: ScrollBehavior = 'smooth') => {
    window.scrollTo({
      top: 0,
      behavior
    });
  }, []);

  const scrollToSection = useCallback((sectionId: string, offset: number = 120) => {
    // Check if we're on the homepage
    if (window.location.pathname === '/') {
      scrollToElement(sectionId, offset);
    } else {
      // If not on homepage, navigate to homepage with hash
      window.location.href = `/#${sectionId}`;
    }
  }, [scrollToElement]);

  return {
    scrollToElement,
    scrollToTop,
    scrollToSection
  };
}; 